import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import ScrollableTable from "../../components/table/ScrollableTable";
import { authGetRequest } from "../../utils/authGetRequest";
import { TableHeader } from "../../components/table/TableHeader";
import Utils from "../../utils/Utils";
import TableSkeleton from "../../components/table/TableSkeleton";
import { AppContext } from "../../context/state";
import Link from "next/link";
import useInfiniteScroll from "../../components/hooks/useInfiniteScroll";
import useWindowResize from "../../components/hooks/useWindowResize";
import transformTime from "../[league]/linevalue-welcome/utils/transformTime";
import transformDate from "../[league]/linevalue-welcome/utils/transformDate";
import { getDefYear } from "../../constants/main";
function useQuery() {
  return new URLSearchParams();
}

const miscTableHeader = [
  {
    title: "Date",
    showImage: false,
    sortable: true,
    key: "Date",
  },
  {
    title: "Time (ET)",
    showImage: false,
    sortable: true,
    key: "Time",
  },
  {
    title: "Home Team",
    showImage: false,
    sortable: true,
    key: "Home",
  },
  {
    title: "Score",
    showImage: false,
    sortable: true,
    key: "Projected Home Score",
  },
  {
    title: "Away Team",
    showImage: false,
    sortable: true,
    key: "Away",
  },
  {
    title: "Score",
    showImage: false,
    sortable: true,
    key: "Projected Away Score",
  },
  {
    title: "Projected",
    showImage: false,
    sortable: true,
    key: "Projected (Home)",
    // offen: "hmarg",
    // defen: "tot",
  },
  {
    title: "Consensus",
    showImage: false,
    sortable: true,
    key: "Consensus",
    offen: "concen",
    defen: "concentot",
  },
  {
    title: "Side with Value",
    showImage: false,
    sortable: true,
    key: "Side with Value",
    offen: "teamval",
    defen: "totside",
  },
  {
    title: "Points of Value",
    showImage: false,
    sortable: true,
    key: "Points of Value",
    offen: "finalval",
    defen: "totalval",
  },
  {
    title: "Play",
    showImage: false,
    sortable: true,
    key: "play",
  },
  {
    title: "Selected Book",
    showImage: false,
    sortable: false,
    key: "BKM.Side",
    tier1: ["concen", "concentot"],
    tier2: ["Opener.Side", "Opener.Total"],
    tier3: ["BKM.Side", "BKM.Total"],
    tier4: ["PIN.Side", "PIN.Total"],
    tier5: ["X5D.Side", "X5D.Total"],
    tier6: ["BOV.Side", "BOV.Total"],
    tier7: ["BOL.Side", "BOL.Total"],
    tier8: ["SIA.Side", "SIA.Total"],
  },
];

const lockSvg = (
  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.25 8V5.5325C13.248 4.19841 12.7172 2.91952 11.7738 1.97618C10.8305 1.03283 9.55159 0.501984 8.2175 0.5H7.7825C6.44841 0.501984 5.16952 1.03283 4.22618 1.97618C3.28283 2.91952 2.75198 4.19841 2.75 5.5325V8C2.15326 8 1.58097 8.23705 1.15901 8.65901C0.737053 9.08097 0.5 9.65326 0.5 10.25V17.225C0.501983 18.3582 0.95302 19.4444 1.75431 20.2457C2.5556 21.047 3.64181 21.498 4.775 21.5H11.225C12.3582 21.498 13.4444 21.047 14.2457 20.2457C15.047 19.4444 15.498 18.3582 15.5 17.225V10.25C15.5 9.65326 15.2629 9.08097 14.841 8.65901C14.419 8.23705 13.8467 8 13.25 8ZM4.25 5.5325C4.25 4.59562 4.62217 3.69712 5.28465 3.03465C5.94712 2.37217 6.84562 2 7.7825 2H8.2175C9.15438 2 10.0529 2.37217 10.7154 3.03465C11.3778 3.69712 11.75 4.59562 11.75 5.5325V8H4.25V5.5325ZM14 17.225C14 17.961 13.7076 18.6668 13.1872 19.1872C12.6668 19.7076 11.961 20 11.225 20H4.775C4.03902 20 3.33319 19.7076 2.81278 19.1872C2.29237 18.6668 2 17.961 2 17.225V10.25C2 10.0511 2.07902 9.86032 2.21967 9.71967C2.36032 9.57902 2.55109 9.5 2.75 9.5H13.25C13.4489 9.5 13.6397 9.57902 13.7803 9.71967C13.921 9.86032 14 10.0511 14 10.25V17.225Z"
      fill="#0F131B"
    />
    <path
      d="M8.75 14.5412V17.0012C8.75 17.2001 8.67098 17.3909 8.53033 17.5316C8.38968 17.6722 8.19891 17.7512 8 17.7512C7.80109 17.7512 7.61032 17.6722 7.46967 17.5316C7.32902 17.3909 7.25 17.2001 7.25 17.0012V14.5412C6.96404 14.3761 6.74054 14.1213 6.61418 13.8162C6.48782 13.5111 6.46565 13.1729 6.55111 12.854C6.63657 12.535 6.82489 12.2532 7.08686 12.0522C7.34882 11.8511 7.6698 11.7422 8 11.7422C8.3302 11.7422 8.65118 11.8511 8.91314 12.0522C9.17511 12.2532 9.36343 12.535 9.44889 12.854C9.53435 13.1729 9.51218 13.5111 9.38582 13.8162C9.25946 14.1213 9.03596 14.3761 8.75 14.5412Z"
      fill="#0F131B"
    />
  </svg>
);

let ascOrder = true;

const SecondScreen = ({ setScreen, authToken, setManuallyReset, cookies, user, uniqUserId }) => {
  let query = useQuery();
  const { store, handleSummaryData } = useContext(AppContext);

  const tableRef = useRef();
  const [summaryData, setSummaryData] = useState(null);
  const [pointsOfValueFilteredData, setPointsOfValueFilteredData] = useState(null);
  const [filteredSummaryData, setFilteredSummaryData] = useState(null);
  const [selectedThresholdValue, setSelectedThresholdValue] = useState(4);
  const [teamData, setTeamData] = useState([]);
  const [filteredTeamData, setFilteredTeamData] = useState([]);
  const [sortedKey, setSortedKey] = useState("");
  const [tableLoaded, setTableLoaded] = useState(false);
  const [columnType, setColumnType] = useState(() => {
    return query.get("columnType") ?? "offen";
  });
  const windowSize = useWindowResize();
  const [isSpread, setIsSpread] = useState(true);
  const [slicedArray] = useInfiniteScroll(
    {
      array: filteredTeamData,
      scrollType: windowSize?.["width"] > 768 ? "window" : "parent",
      parentRef: tableRef,
      itemsPerView: 35,
    },
    [teamData]
  );
  const isPremiumPlan = Utils.hasPremiumPlan(user);

  const SQScoreHeader = [
    {
      title: lockSvg,
      showImage: false,
      sortable: false,
      key: "88-88",
      classList: ["dummyLockToolTip"],
      tooltip: {
        title: "Only available to ShotQuality premium",
        text: "Available to existing ShotQuality Premium members. Plan upgrades are no longer available.",
        link: "/login",
      },
    },
  ];

  useEffect(() => {
    setPointsOfValueFilteredData(
      teamData.map((option) => {
        return {
          ...option,
          Play: option["Points of Value"] >= selectedThresholdValue,
        };
      })
    );
  }, [teamData, selectedThresholdValue]);

  const sort = (key) => {
    let res = [];

    let rawData = filterDataByCategory();

    let replaceKey;
    const headerObj = miscTableHeader.filter((column) => column["key"] === key)[0];

    replaceKey = headerObj["key"];
    if (key === "play") {
      replaceKey = "finalval";
    }

    if (key === "concen") {
      if (columnType === "defen") {
        replaceKey = "concentot";
      } else {
        replaceKey = "concen";
      }
    }

    if (key === "finalval") {
      if (columnType === "defen") {
        replaceKey = "totalval";
      } else {
        replaceKey = "finalval";
      }
    }
    let keySumm = {};

    if (key === "Projected (Home)" && columnType == "defen") {
      replaceKey = "summaryColumns";
      keySumm["key1"] = "Projected Home Score";
      keySumm["key2"] = "Projected Away Score";
    }

    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";

      res = rawData.sort(Utils.dynamicsort(replaceKey, order, keySumm));
      ascOrder = order === "desc";
    } else {
      ascOrder = false;
      setSortedKey(key);
      res = rawData.sort(Utils.dynamicsort(replaceKey, null, keySumm));
    }
    setFilteredTeamData([...res]);
  };

  const [tableType, setTableType] = useState(() => {
    return "tier1";
  });
  let leagueYear = getDefYear(store.leagueType);
  const handleTableTypeChange = (e) => {
    setTableType(e.target.value);
  };
  const filterDataByCategory = useCallback(() => {
    if (pointsOfValueFilteredData) {
      let rawData = pointsOfValueFilteredData;
      if (columnType == "offen") {
        rawData = rawData.filter((game) => {
          if (game.is_spread) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        rawData = pointsOfValueFilteredData.filter((game) => {
          if (!game.is_spread) {
            return true;
          } else {
            return false;
          }
        });
      }
      return rawData;
    }
  });

  const handleColumnTypeChange = (e) => {
    setColumnType(e.target.value);
    setIsSpread(e.target.value === "offen" ? true : false);
  };

  let today = new Date();

  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();
  today = `${yyyy}-${mm}-${dd}`;
  // 2021-11-9
  useEffect(() => {
    if (user) {
      setTableLoaded(false);
      authGetRequest(`/api/${store.leagueType}/model-sandbox/model/value-finder`, authToken)
        .then((d) => d.data)
        .then((data) => {
          // the commented code below filters data only for today's games and future games
          // const todaysMatches = data[cookies.name].filter((game) => {
          //   let arrayOfStrings = game.Date.split("-");
          //   let arrayOfNumbers = arrayOfStrings.map((string) =>
          //     parseInt(string)
          //   );

          //   if (
          //     arrayOfNumbers[0] === parseInt(yyyy) &&
          //     arrayOfNumbers[1] >= parseInt(mm) &&
          //     arrayOfNumbers[2] >= parseInt(dd)
          //   ) {
          //     return game;
          //   } else if (arrayOfNumbers[0] > parseInt(yyyy)) {
          //     return game;
          //   }
          // });

          setTeamData(data.data);
          setTableLoaded(true);
        })
        .catch((err) => {
          setTableLoaded(true);
          console.error(err);
        });

      authGetRequest(`/api/${store.leagueType}/model-sandbox/model-summary`, authToken)
        .then((data) => data.data)
        .then((data) => {
          setSummaryData(data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      fetch(
        `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${store.leagueType}/model-sandbox/model/value-finder/${uniqUserId}/unprotected`
      )
        .then((d) => d.json())
        .then((data) => {
          setTeamData(data.data);
          setTableLoaded(true);
        })
        .catch((err) => {
          setTableLoaded(true);
          console.error(err);
        });

      fetch(
        `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${store.leagueType}/model-sandbox/model-summary/${uniqUserId}/unprotected`
      )
        .then((data) => data.json())
        .then((data) => {
          setSummaryData(data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [authToken, uniqUserId, user]);

  useEffect(() => {
    if (summaryData) {
      setFilteredSummaryData(
        summaryData.filter((data) => data.value_threshold === selectedThresholdValue && data.type === "all")[0]
      );
      handleSummaryData(selectedThresholdValue, summaryData, filteredSummaryData);
    }
  }, [summaryData, selectedThresholdValue, handleSummaryData, filteredSummaryData]);

  useEffect(() => {
    if (pointsOfValueFilteredData) {
      setFilteredTeamData([...filterDataByCategory()]);
    }
  }, [columnType, tableLoaded, pointsOfValueFilteredData]);

  const changeSelectionHandler = () => {
    localStorage.setItem("manuallyReset", true);
    setScreen("first");
  };
  return (
    <section className="header-secondary">
      <div className="container-fluid">
        <button
          style={{
            background: "transparent",
            border: 0,
            color: "#0F131B",
            fontSize: "16px",
            fontWeight: 700,
            marginTop: "10px",
            marginBottom: "30px",
          }}
          onClick={() => changeSelectionHandler()}
        >
          {"<  "} Back to change selection
        </button>

        <div className="row d-flex justify-content-between align-items-center">
          {/* <div className='row'> */}
          <div className="col-md-12">
            <h1 className="text-left" style={{ fontSize: "36px" }}>
              Model Projections
            </h1>
          </div>
        </div>

        <div
          className="row d-flex mt-5 justify-content-between align-items-center"
          style={{
            backgroundColor: "#fff",
            boxShadow: "2px 4px 30px rgba(107, 108, 114, 0.12)",
            borderRadius: "12px",
            padding: "30px 50px 30px 40px",
          }}
        >
          {filteredSummaryData ? (
            <>
              <div className="col-md-6" style={{ borderRight: "1px solid #D0D2D9" }}>
                <div style={{}}>
                  <h2>Overall</h2>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#0F131B",
                      marginTop: "16px",
                    }}
                  >
                    Your model is{" "}
                    <span
                      style={{ color: "#F26B0B" }}
                    >{`${filteredSummaryData?.Wins}-${filteredSummaryData.Losses}-${filteredSummaryData.Pushes}`}</span>{" "}
                    on plays of {`${selectedThresholdValue}`} points of
                    <br /> value, winning <span style={{ color: "#F26B0B" }}>{filteredSummaryData.Units}</span> units
                    with a <span style={{ color: "#F26B0B" }}>{filteredSummaryData.ROI}</span> ROI
                  </p>
                </div>
              </div>
              <div className="col-md-6 Overall">
                <div className="text-center">
                  <p>Your model</p>{" "}
                  <h3
                    style={{
                      fontWeight: 700,
                      fontFamily: "var(--font-oswald)",
                      fontSize: "32px",
                    }}
                  >
                    {`${filteredSummaryData?.Wins}-${filteredSummaryData.Losses}-${filteredSummaryData.Pushes}`}
                  </h3>
                </div>
                <div className="text-center">
                  <p>Winning</p>{" "}
                  <h3
                    style={{
                      fontWeight: 700,
                      fontFamily: "var(--font-oswald)",
                      fontSize: "32px",
                    }}
                  >
                    {filteredSummaryData.Units}
                  </h3>
                </div>
                <div className="text-center">
                  <p>Units with</p>{" "}
                  <h3
                    style={{
                      fontWeight: 700,
                      fontFamily: "var(--font-oswald)",
                      fontSize: "32px",
                    }}
                  >
                    {filteredSummaryData.ROI} ROI
                  </h3>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div className="row d-flex model-sandbox-buttons mt-5 justify-content-between ">
          <div style={{ background: "#0F131B", borderRadius: "10px" }} className="btn-group col-md-3 p-0">
            <button
              type="button"
              className={`btn btn-lg btn-primary value-finder-buttons-group ${columnType === "defen" ? "active" : ""}`}
              value="defen"
              onClick={(e) => {
                handleColumnTypeChange(e);
              }}
            >
              Projected Total
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary value-finder-buttons-group ${columnType === "offen" ? "active" : ""}`}
              value="offen"
              onClick={(e) => {
                handleColumnTypeChange(e);
              }}
            >
              Projected Spread
            </button>
          </div>
          <div
            id="pov-buttons"
            className="d-flex col-md-4 align-items-flexbase justify-content-between"
            style={{
              background: "#0F131B",
              borderRadius: "10px",
            }}
          >
            <p
              style={{
                color: "white",
                marginRight: "40px",
                paddingTop: "16px",
              }}
            >
              Points of value threshold
            </p>
            <div className="align-items-flexbase justify-content-left pointsValueNumbers pt-3 ">
              <button
                className={`${selectedThresholdValue === 4 ? "threshold-btn-active" : ""} threshold-btn`}
                style={{ marginRight: "20px" }}
                onClick={() => {
                  setSelectedThresholdValue(4);
                }}
              >
                4
              </button>
              <button
                className={`${selectedThresholdValue === 6 ? "threshold-btn-active" : ""} threshold-btn btn-space`}
                onClick={() => {
                  setSelectedThresholdValue(6);
                }}
              >
                6
              </button>
              <button
                className={`${selectedThresholdValue === 8 ? "threshold-btn-active" : ""} threshold-btn`}
                onClick={() => {
                  setSelectedThresholdValue(8);
                }}
              >
                8
              </button>
            </div>
          </div>
          <div id="export-button-wrapper" style={{ marginLeft: 0, padding: 0 }} className="col-md-4 d-flex">
            <button
              className="btn btn-primary exportBtn d-flex"
              style={{
                padding: "16px 46px",
                marginRight: "20px",
                marginLeft: 0,
              }}
              // onClick={onSubmitClick}
              // type="submit"
              disabled={!isPremiumPlan}
            >
              Export to CSV
              <AiOutlineDownload />
            </button>
            <button
              className="btn btn-secondary d-flex"
              style={{ padding: "16px 46px" }}
              onClick={() => setScreen("third")}
              // onClick={onSubmitClick}
              // type="submit"
              // disabled={onClicked}
              disabled={!selectedThresholdValue || !summaryData || !filteredSummaryData}
            >
              Betting Trends
            </button>
          </div>
        </div>

        <div
          style={{
            marginTop: "3%",
            display: "flex",
            justifyContent: "flex-start",
            marginLeft: "0",
            paddingLeft: "0",
          }}
          className="col-xs-12 col-sm-9 text-center buttons-category-container"
        >
          <div sty className="btn-group-justified">
            <button
              type="button"
              style={{ marginLeft: "0" }}
              className={`btn btn-lg btn-primary ${tableType === "Consensus" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="Consensus"
            >
              Consensus
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "Opener" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="Opener"
            >
              Opener
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "Bookmaker" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="Bookmaker"
            >
              Bookmaker
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "Pinacle" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="Pinacle"
            >
              Pinacle
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "5Dimes" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="5Dimes"
            >
              5Dimes
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "Bovada" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="Bovada"
            >
              Bovada
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "BetOnline" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="BetOnline"
            >
              BetOnline
            </button>
            <button
              type="button"
              className={`btn btn-lg btn-primary ${tableType === "SIA" ? "active" : ""}`}
              onClick={handleTableTypeChange}
              value="SIA"
            >
              SIA
            </button>
          </div>
        </div>
        <div>
          <ScrollableTable top="0px" ref={tableRef}>
            <div className="table-responsive table-space">
              {!tableLoaded ? (
                <TableSkeleton
                  tableHeader={miscTableHeader}
                  tableRowsCount={10}
                  className="table-space"
                  tableHeaderHeight="90px"
                ></TableSkeleton>
              ) : null}

              <table className="table tl-fixed-desktop" style={{ position: "relative" }}>
                <thead className="sticky-th-2">
                  <tr className="text-center">
                    <TableHeader
                      headers={miscTableHeader}
                      onSortClick={sort}
                      ascOrder={ascOrder}
                      sortedKey={sortedKey}
                    />
                  </tr>
                </thead>
                <tbody>
                  {tableLoaded &&
                    teamData.length &&
                    slicedArray?.map((team, index) => {
                      let rankKey = columnType === "offen" ? "offen" : "defen";
                      const rankConfig = {
                        leagueType: store.leagueType,
                        isPercent: columnType === "frequency" ? false : false,
                      };

                      return (
                        <tr key={`${team["Date"]}_${team["Time"]}_${team["Home"]}_${team["Away"]}_${index}`}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {transformDate(team["Date"])}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {transformTime(team["Time"])}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Link
                              href={`/team/${store.leagueType}/${leagueYear}/${team["Home"]}`}
                              style={{ color: "#212529" }}
                              target={"_blank"}
                            >
                              <img
                                src={`http://shotqualitybets.com/static/media/logos/${team["Home"]}.png`}
                                alt={""}
                                className="img-fluid w-25 pull-left GameCard__team--logo logo-left2"
                              />
                              &nbsp;
                              {team["Home"]}
                            </Link>
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                78.9
                              </>
                            ) : (
                              team["Projected Home Score"]
                            )}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Link
                              href={`/team/${store.leagueType}/${leagueYear}/${team["Away"]}`}
                              style={{ color: "#212529" }}
                              target={"_blank"}
                            >
                              <img
                                src={`http://shotqualitybets.com/static/media/logos/${team["Away"]}.png`}
                                alt={""}
                                className="img-fluid w-25 pull-left GameCard__team--logo logo-left2"
                              />
                              &nbsp;
                              {team["Away"]}
                            </Link>
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                78.9
                              </>
                            ) : (
                              team["Projected Away Score"]
                            )}
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                78.9
                              </>
                            ) : columnType === "offen" ? (
                              parseFloat(String(team["Projected Away Score"] - team["Projected Home Score"])).toFixed(1)
                            ) : (
                              parseFloat(String(team["Projected Away Score"] + team["Projected Home Score"])).toFixed(1)
                            )}
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                -4.5
                              </>
                            ) : (
                              team["Consensus"]
                            )}
                          </td>

                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                Untitled
                              </>
                            ) : (
                              team["Side with Value"]
                            )}
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                +4.8
                              </>
                            ) : (
                              team["Points of Value"]
                            )}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {team["Play"] ? "Play" : ""}
                          </td>
                          <td
                            style={
                              !isPremiumPlan
                                ? {
                                    textAlign: "center",
                                    color: "transparent",
                                    textShadow: "0 0 7px #000",
                                    position: "relative",
                                  }
                                : {
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }
                            }
                          >
                            {!isPremiumPlan ? (
                              <>
                                <TableHeader headers={SQScoreHeader} />
                                +4.5
                              </>
                            ) : columnType === "defen" ? (
                              team[tableType]
                            ) : team["Side with Value"] == team["Away"] ? (
                              team[tableType] < 0 ? (
                                "+" + -1 * team[tableType]
                              ) : team[tableType] > 0 ? (
                                -1 * team[tableType]
                              ) : (
                                ""
                              )
                            ) : team[tableType] < 0 ? (
                              team[tableType]
                            ) : "" ? (
                              team[tableType]
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </ScrollableTable>
        </div>
      </div>
    </section>
  );
};

export default SecondScreen;
